export const colors = {
  primaryColor: '#2c82c9',
  secondaryColor: '#26cad3',
  tertiaryColor: '#f9b835',
  successColor: '#00c468',
  errorColor: '#f14643',
  bgPrimaryColor: '#eaebed',
  bgSecondaryColor: '#f4f5f6',
  bgTertiaryColor: '#f9fafa',
  bgLightestColor: '#fff',
  primaryFontColor: '#2e3d49',
  secondaryFontColor: '#969ea4',
  lightestFontColor: '#fff',
  //portal app
  white: '#fff',
  grey900: '#3a474e',
  indigo500: '#7568d8',
  errorDark: '#de3535',
  blue700: '#0071bc',
  colorPositive: '#2A874A',
  colorSuccess: '#14af6e',
  loadingColor: '#0099CC',
  ellipsisHighlightColor: '#1B63CE',
  ellipsisColor: '#DCE1E6',
  informative: '#007bc4',
  warning: '#e8c928',
  teamsIcon: '#eb7634',
} as const;

export const coBrandingDefaults = {
  text: colors.lightestFontColor,
  textDark: colors.primaryFontColor, // Needs removal with refactor
  primary: colors.primaryColor,
  secondary: colors.secondaryColor,
} as const;
